import { render, staticRenderFns } from "./EzDropdown.vue?vue&type=template&id=bfa6f156&scoped=true&"
import script from "./EzDropdown.vue?vue&type=script&lang=js&"
export * from "./EzDropdown.vue?vue&type=script&lang=js&"
import style0 from "./EzDropdown.vue?vue&type=style&index=0&id=bfa6f156&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa6f156",
  null
  
)

export default component.exports